import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";

interface AddMultiPhone {
  id: number,
  value: string
}

export class OrganizationStore {
    showLoader: boolean = false;
    newOrganization:number = 1;
    rolelabel: string = "";
    orgOrganization: OrganizationType[] = [];
    userAddOrganizationbarPermissionSelection: boolean = false;
    userEditOrganizationbarPermissionSelection:boolean = false;
    AddOrganizationbarCloser:boolean = false;
    legalEntryName:string ="";
    address:string = "";
    phoneNumber:string[] =[];
    email:string[] =[];
    id : string="";
    update : number = 0;

    addOrgPhoneNumber: AddMultiPhone[] = [{id: 1, value: ""}];


    rootStore: IRootStore;

    constructor(rootStore: IRootStore) { 
        makeAutoObservable(this);

        this.rootStore = rootStore;

    }
    setOrganizationList = (orgList: OrganizationType[]) => {
        this.orgOrganization = orgList;
      }
      get getOrganizationList() {
        return this.orgOrganization;
      }
      handleAddOrganizationbar = (isRSidebarShow: boolean) => {
        this.userAddOrganizationbarPermissionSelection = isRSidebarShow;
    }
    get getOrganizationbarShow() {
        return this.userAddOrganizationbarPermissionSelection;
    }
    handleEditOrganizationbar = (isRSidebarShow: boolean) => {
      this.userEditOrganizationbarPermissionSelection = isRSidebarShow;
  }
  get getEditOrganizationbarShow() {
      return this.userEditOrganizationbarPermissionSelection;
  }
  handleAddOrganizationCloser = (value :boolean ) =>{
    this.AddOrganizationbarCloser = value;
  }
  get getAddOranizationCloser () {
    return this.AddOrganizationbarCloser;
  }
  handlelegalEntryName = (legalEntryName: string) => {
    this.legalEntryName = legalEntryName;
}
get getid() {
    return this.id;
}
handleid = (id:string) =>{
  this.id = id;
}
get getlegalEntryName() {
    return this.legalEntryName;
}
handleAdress = (address:string) =>{
  this.address = address;
}
get getAddress (){
  return this.address;
}
handlePhoneNumber = (phoneNuber:string[]) =>{
  this.phoneNumber = phoneNuber;

}
get getphoneNumber (){

  return this.phoneNumber;
}
handleEmail = (email:string[]) =>{
  this.email = email;
}
get getEmail (){
  return this.email;
}
handleupdate = () => {
  this.update++;
}
get getupdate () {
  return this.update ;
}

handleAddOrgPhoneNumber = (obj: AddMultiPhone) => {
  this.addOrgPhoneNumber = this.addOrgPhoneNumber.map(phone =>
    phone.id === obj.id ? { ...phone, value: obj.value } : phone
  );
};

get getAddOrgPhoneNumber() {
  return this.addOrgPhoneNumber;
}

addPhoneNumberRow = () => {

}

}